import {
  fetchFields,
  reorderCustomAttributes,
  createAttribute,
  toggleFieldForm,
  deleteField,
  editAttribute,
  fetchFieldUsage,
  fetchFieldDefinitions,
  editSystemFields,
} from '../routines';
import responseFormatter from '../../common/util/ResponseFormatter';

const initialState = {
  fieldList: {
    organization: {},
    account: {},
    contact: {},
    pipeline: {},
  },
  loading: {
    organization: false,
    account: false,
    contact: false,
    pipeline: false,
  },
  errors: {
    organization: false,
    account: false,
    contact: false,
    pipeline: false,
  },
  create: {
    loading: false,
    error: null,
    showFieldForm: false,
  },
  fieldUsage: {
    data: null,
    error: null,
    loading: false,
  },
  idFieldLookup: {}, // experimental
};

const fieldDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchFieldUsage.TRIGGER: {
      return {
        ...state,
        fieldUsage: {
          data: null,
          error: null,
          loading: true,
        },
      };
    }
    case fetchFieldUsage.SUCCESS: {
      return {
        ...state,
        fieldUsage: {
          data: action.payload.response.data,
          error: null,
          loading: false,
        },
      };
    }
    case fetchFieldUsage.FAILURE: {
      return {
        ...state,
        fieldUsage: {
          data: null,
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case toggleFieldForm.TRIGGER: {
      return {
        ...state,
        create: {
          ...state.create,
          showFieldForm: action.payload.showForm,
        },
      };
    }
    case editSystemFields.TRIGGER:
    case editAttribute.TRIGGER:
    case createAttribute.TRIGGER: {
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    }
    case editSystemFields.FAILURE:
    case editAttribute.FAILURE:
    case createAttribute.FAILURE: {
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    }
    case editSystemFields.SUCCESS:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
          showFieldForm: false,
        },
      };
    case editAttribute.SUCCESS: {
      const { level } = action.payload;
      const { data } = action.payload.response;

      let levelList = { ...state.fieldList[level] };
      levelList = { ...levelList, [data.name]: data };
      const fieldList = {
        ...state.fieldList,
        [level]: levelList,
      };
      return {
        ...state,
        fieldList,
        create: {
          ...state.create,
          loading: false,
          showFieldForm: false,
        },
      };
    }
    case createAttribute.SUCCESS: {
      const { level } = action.payload;
      const { data } = action.payload.response;
      const fieldList = {
        ...state.fieldList,
      };
      fieldList[level] = { [data.name]: data, ...fieldList[level] };
      return {
        ...state,
        fieldList,
        create: {
          ...state.create,
          loading: false,
          showFieldForm: false,
        },
      };
    }
    case deleteField.TRIGGER:
    case fetchFields.TRIGGER: {
      const { level } = action.payload;
      const loading = { ...state.loading };
      loading[level] = true;
      return {
        ...state,
        loading,
      };
    }
    case deleteField.SUCCESS: {
      const { level } = action.payload;
      const { name } = action.payload;

      const levelListObj = { ...state.fieldList[level] };
      const fieldList = {
        ...state.fieldList,
      };
      delete levelListObj[name];
      fieldList[level] = levelListObj;
      const loading = { ...state.loading };
      loading[level] = false;
      return {
        ...state,
        fieldList,
        loading,
      };
    }
    case fetchFieldDefinitions.SUCCESS: {
      const idFieldLookup = {
        ...state.idFieldLookup,
        ...responseFormatter(
          Object.values(action.payload.allDefinitions),
          'customColumnId',
          'map'
        ),
      };

      return { ...state, idFieldLookup };
    }
    case fetchFields.SUCCESS: {
      const { level } = action.payload;
      const { data } = action.payload.response;
      const fieldList = {
        ...state.fieldList,
      };
      fieldList[level] = data;
      const loading = { ...state.loading };
      loading[level] = false;
      // experimental
      const idFieldLookup = {
        ...state.idFieldLookup,
        ...responseFormatter(Object.values(data), 'customColumnId', 'map'),
      };
      // experimental
      return {
        ...state,
        fieldList,
        loading,
        idFieldLookup,
      };
    }
    case fetchFields.FAILURE: {
      const { level } = action.payload;
      const error = action.payload.FAILURE;
      const errors = {
        ...state.fieldList,
      };
      errors[level] = error;
      const loading = { ...state.loading };
      loading[level] = false;
      return {
        ...state,
        errors,
        loading,
      };
    }
    case reorderCustomAttributes.TRIGGER: {
      const { level, fields } = action.payload;
      const fieldList = {
        ...state.fieldList,
      };
      fieldList[level] = {
        ...responseFormatter(Object.values(fields), 'name', 'map'),
      };

      const loading = { ...state.loading };
      loading[level] = true;
      return {
        ...state,
        fieldList,
        loading,
      };
    }
    case reorderCustomAttributes.SUCCESS: {
      const { level } = action.payload;
      const loading = { ...state.loading };
      loading[level] = false;
      return { ...state, loading };
    }
    case reorderCustomAttributes.FAILURE: {
      const { level } = action.payload;
      const loading = { ...state.loading };
      loading[level] = false;
      return { ...state, loading };
    }
    default:
      return state;
  }
};

export default fieldDataReducer;
